module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_6005.80aaa3b6.png";